import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BaseApp } from '@subscription-destroyer';
import * as moment from 'moment';
import { UserTokenResponse } from 'src/app/shared-resources/interfaces/base-core-services.interface';
import {
  HttpErrorHandlerService,
  MessageType,
} from 'src/app/shared-resources/services/http-error-handling.service';
import { LoginRequest } from '../../interfaces/login.interface';
import { ForgotPassService } from '../../services/forgot-password';
import { LoginService } from '../../services/login.service';
import { UserInfoService } from '@shared-services/user-info.service';
export interface CaptchaImageAndKey {
  captchaKey: string;
  encodedCaptchaImage: string;
}

@Component({
  selector: 'app-login-admin',
  templateUrl: './login-admin.component.html',
  styleUrls: ['./login-admin.component.less'],
  providers: [BaseApp],
})
export class LoginAdminComponent implements OnInit {
  public validateForm: FormGroup;
  public passwordVisible = false;
  public password: string;
  public customRoles = [];
  public loading = false;
  public captchaImageUrl: string = '';
  public captchaKey: string = 'test';
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private loginService: LoginService,
    private httpMessage: HttpErrorHandlerService,
    private translate: TranslateService,
    private forgotPassService: ForgotPassService,
    private subscription: BaseApp,
    private userInfoService : UserInfoService
  ) {}
  signup(): void {
    this.router.navigateByUrl('/signup');
  }
  forgotpassword(): void {
    this.router.navigateByUrl('/forgot-password');
  }

  goto(): void {
    for (const i in this.validateForm.controls) {
      if (i) {
        this.validateForm.controls[i].markAsDirty();
        this.validateForm.controls[i].updateValueAndValidity();
      }
    }
    this.loading = true;
    if (this.validateForm.valid) {
      const loginBody: LoginRequest = {
        username: this.validateForm.value.userName,
        password: this.validateForm.value.password,
        captchaAnswer: this.validateForm.value.captcha,
        captchaKey: this.captchaKey,
      };
      this.loginService.login(loginBody).subscribe(
        (res: UserTokenResponse) => {
          if (res.userType === 'admin_user') {
            this.loginService.setUserData(
              res,
              this.validateForm.value.userName
            );
            this.userInfoService.setUserToken((res.token.accessToken ? res.token.accessToken : ""), res.token.expiresIn);
            this.userInfoService.setUserInfoTab(res.user);
            sessionStorage.setItem(
              'tokenExpiryTime',
              JSON.stringify(res.token.expiresIn)
            );
            sessionStorage.setItem(
              'tokenExpiryDate',
              moment(new Date()).add(res.token.expiresIn, 'seconds').toString()
            );
            localStorage.setItem(
              'tokenExpiryTime',
              JSON.stringify(res.token.expiresIn)
            );
            localStorage.setItem(
              'tokenExpiryDate',
              moment(new Date()).add(res.token.expiresIn, 'seconds').toString()
            );

            this.router.navigateByUrl('/app/landing');
            this.loading = false;
          } else {
            this.httpMessage.showTopFloatMessage(
              this.translate.instant('app.label.only-admin-allowed'),
              MessageType.ERROR,
              this.translate.instant('app.label.unauthorised')
            );
            this.loading = false;
          }
        },
        (error: HttpErrorResponse) => {
          this.getCaptchaImageAndKey();
          this.validateForm.controls.captcha.reset();
          this.httpMessage.showTopFloatMessage(
            error.error,
            MessageType.ERROR,
            this.translate.instant('app.signin.failed.title')
          );
          this.loading = false;
        }
      );
    } else {
      this.loading = false;
      this.validateForm.controls.captcha.reset();
      this.getCaptchaImageAndKey();
    }
  }
  ngOnInit(): void {
    this.validateForm = this.fb.group({
      userName: ['', [Validators.required]],
      password: ['', [Validators.required]],
      remember: [true],
      captcha: ['', [Validators.required]],
    });
    this.getCaptchaImageAndKey();
  }

  getCaptchaImageAndKey() {
    this.subscription.subs.add(
      this.forgotPassService
        .getCaptchaImageAndKey()
        .subscribe((res: CaptchaImageAndKey) => {
          this.captchaImageUrl =
            'data:image/jpg;base64,' + res.encodedCaptchaImage;
          this.captchaKey = res.captchaKey;
        })
    );
  }
}
